import { render, staticRenderFns } from "./PendingTaskToUploadVideoBanner.vue?vue&type=template&id=1c9dd302&scoped=true"
import script from "./PendingTaskToUploadVideoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingTaskToUploadVideoBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PendingTaskToUploadVideoBanner.vue?vue&type=style&index=0&id=1c9dd302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9dd302",
  null
  
)

export default component.exports